import { Group, Highlight, Stack, Text } from "@mantine/core";
import { spotlight, Spotlight } from "@mantine/spotlight";
import { generatePath, useNavigate } from "react-router";
import { usePerson } from "../../../hooks/usePerson";
import { ROUTES } from "../../../routes";
import { MENU_ITEMS } from "../../Menu/Menu.constants";
import type { TQuicksearchPerson } from "../Quicksearch.types";
import { Quicklink } from "./Quicklink";
import { QuicklinkLoader } from "./QuicklinkLoader";

function QuicksearchUnternehmen({
  item,
  highlight = []
}: {
  item: TQuicksearchPerson;
  highlight?: string[];
}) {
  const navigate = useNavigate();
  const { data: person, isLoading } = usePerson(item.id);

  const handleClick = () => {
    navigate(
      generatePath(ROUTES.project.companiesWithId, {
        projectId: item.project_id,
        companyId: String(item.id)
      })
    );
    spotlight.close();
  };

  return (
    <Group justify="space-between" key={item.name}>
      <Spotlight.Action flex={1} w="auto" onClick={handleClick}>
        <Stack gap={0}>
          <Highlight highlight={highlight}>{item.name}</Highlight>
          {item.mastr_nummer_marktakteur && (
            <Text opacity={0.6} size="xs">
              MaStR: {item.mastr_nummer_marktakteur}
            </Text>
          )}
        </Stack>
      </Spotlight.Action>
      <Group gap="xs">
        {isLoading && <QuicklinkLoader />}
        {person?.isErloesmonitoringActive && (
          <>
            <Quicklink
              Icon={MENU_ITEMS.REVENUE_MONITORING.icon}
              label={`${MENU_ITEMS.REVENUE_MONITORING.label} für ${item.name}`}
              to={generatePath(
                `${MENU_ITEMS.REVENUE_MONITORING.url}?companyId=${item.id}`,
                {
                  projectId: item.project_id
                }
              )}
            />
          </>
        )}
      </Group>
    </Group>
  );
}

export { QuicksearchUnternehmen };
